module.exports = __webpack_public_path__ + "img/banner2-1@1x.b1be5405.jpg";